import Vue from "vue";
import "./plugins/bootstrap-vue";
import BootstrapVue, { BootstrapVueIcons } from "bootstrap-vue";
import VueRouter from "vue-router";
// @ts-ignore
import VueMask from "v-mask";
import Login from "./routes/Login.vue";
import Signup from "./routes/Signup.vue";
import Confirm from "./routes/Confirm.vue";
import Statements from "./routes/Statements.vue";
import Profile from "./routes/Profile.vue";
import store from "./store";
// Your variable overrides
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./font.scss";
import "@/main.scss";



Vue.use(VueRouter);

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueMask);

Vue.config.productionTip = false;
const routes = [
  { path: "*", component: Login },
  { path: "/login", component: Login },
  { path: "/profile", component: Profile },
  { path: "/signup", component: Signup },
  { path: "/confirm", component: Confirm },
  { path: "/statements", component: Statements }
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
export const router = new VueRouter({
  routes
});
new Vue({
  // @ts-ignore
  store,
  router
}).$mount("#app");
